import React from 'react';
import { Grid, Typography, SvgIcon } from '@material-ui/core';
import { ReactComponent as IdVerificationIcon } from '../../assets/icons/id-verification-icon.svg';
import { DOCUMENT_VERIFICATION_STATUS } from 'constants/CommonConstants';
import { TextConstants } from 'constants/TextConstants';
import { useStyles } from './DocumentVerificationBadge.styles';

const DOCUMENT_VERIFICATION_BADGE_CONFIG: Record<string, { label: string }> = {
  [DOCUMENT_VERIFICATION_STATUS.PENDING]: { label: TextConstants.ID_VERIFICATION_REQUIRED },
  [DOCUMENT_VERIFICATION_STATUS.SUCCESS]: { label: TextConstants.ID_VERIFICATION_SUCCESSFUL },
  [DOCUMENT_VERIFICATION_STATUS.FAILED]: { label: TextConstants.ID_VERIFICATION_FAILED },
};

interface DocumentVerificationBadgeProps {
  status?: string;
}

const DocumentVerificationBadge: React.FC<DocumentVerificationBadgeProps> = ({ status }) => {
  const classes = useStyles();
  const badge = status && DOCUMENT_VERIFICATION_BADGE_CONFIG[status];

  if (!badge) {
    return null;
  }

  return (
    <Grid className={[classes.documentVerificationBadge, status].join(' ')} container item>
      <SvgIcon className="icon" component={IdVerificationIcon} viewBox="0 0 18 16" />
      <Typography className="label">{badge.label}</Typography>
    </Grid>
  );
};

export default DocumentVerificationBadge;
